export const formatDateStringToDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("de-DE");
};
